import React from "react";
import { sizeFor } from "../../data/imageSize";

export const ServiceCard = ({
  title,
  description,
  image,
  imageSide,
  subDescription,
  bulletPoints,
  backgroundColor,
  headerTitle,
  subDescription2,
  subDescription3,
  className,
}) => {
  const isImageLeft = imageSide === "left";

  return (
    <>
      {headerTitle ? (
        <div>
          {" "}
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "normal",
              fontFamily: '"Playfair Display", Georgia, serif',
              paddingLeft: "20px",
              textAlign: "center",
              letterSpacing: "2px",
            }}
          >
            {headerTitle}
          </h1>
          <hr className="section-divider" />
        </div>
      ) : null}
      <div
        className={`${
          className?.includes("why-choose-card") ? "" : "animate-fade-up"
        }${className ? ` ${className}` : ""}`}
        style={{
          display: "flex",
          flexDirection: isImageLeft ? "row" : "row-reverse",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
          padding: "3rem",
          backgroundColor: backgroundColor ? backgroundColor : "white",
          borderRadius: "8px",
          textAlign: "center", // Align text for better reading
          alignItems: "center",
          gap: "1rem", // Creates spacing between image and text
          flexWrap: "wrap",
          letterSpacing: "2px",
          width: className?.includes("why-choose-card")
            ? "80%"
            : className?.includes("agent-card")
            ? "85%"
            : className?.includes("founder-card")
            ? "90%"
            : "fit-content(100%)",
          margin: "1.5rem auto",
          justifyContent: "center",
        }}
      >
        <div style={{ flex: "0 1 30vh" }}>
          {" "}
          {image && (
            <img
              src={image}
              alt={title}
              {...sizeFor(image)}
              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
            />
          )}
        </div>
        <div style={{ flex: "1" }}>
          <h3
            style={{
              fontSize: "2rem",
              fontWeight: "normal",
              fontFamily: '"Playfair Display", Georgia, serif',
              paddingLeft: "20px",
              textAlign: "left",
            }}
          >
            <span
              className={
                className?.includes("why-choose-card")
                  ? "why-choose-title"
                  : undefined
              }
            >
              {title}
            </span>
          </h3>
          <div
            style={{
              fontSize: "1rem",
              color: "#4a5568",
              fontFamily: '"Playfair Display", Georgia, serif',
              textAlign: "left",
              paddingLeft: "20px",
            }}
          >
            {description}
            <br></br>
            {bulletPoints && (
              <ul
                style={{
                  maxWidth: "25vh",
                  alignContent: "left",
                  paddingLeft: "2vh",
                }}
              >
                {bulletPoints.map((item, index) => (
                  <li
                    key={index}
                    style={{ textAlign: "left", marginBottom: "8px" }}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
            <br></br>
            <br></br>
            {subDescription}
            {subDescription2 ? (<><br></br><br></br></>) : null}
            {subDescription2}
            {subDescription3 ? (<><br></br><br></br></>) : null}
            {subDescription3}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceCard;
